import { render, staticRenderFns } from "./CoozzyDropdownItemHeader.vue?vue&type=template&id=142f3ed0&scoped=true"
import script from "./CoozzyDropdownItemHeader.vue?vue&type=script&lang=js"
export * from "./CoozzyDropdownItemHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f3ed0",
  null
  
)

export default component.exports